import { render, staticRenderFns } from "./paymentIDTable.html?vue&type=template&id=36c8c20a&scoped=true&"
import script from "./paymentIDTable.js?vue&type=script&lang=js&"
export * from "./paymentIDTable.js?vue&type=script&lang=js&"
import style0 from "./paymentIDTable.scss?vue&type=style&index=0&id=36c8c20a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c8c20a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VPagination,VRow})
